import { collegeProfiles } from "./collegeContent";
// APMERCL Mock Data

export const dignitaries = {
  left: [
    { name: "Shri Nara Chandrababu Naidu", role: "Hon'ble Chief Minister, Government of Andhra Pradesh", img: "/img/chandrababu-naidu.jpg" }
  ],
  right: [
    { name: "Shri Satya Kumar Yadav", role: "Minister of Health, Family Welfare & Medical Education", img: "/img/satya-kumar-yadav.jpg" }
  ]
};

export const stats = [
  { value: 7, label: "Medical colleges", icon: "hospital" },
  { value: 900, label: "MBBS seats / year", icon: "seat" },
  { value: 3485, label: "Students on rolls", icon: "graduation" },
  { value: 734, label: "Faculty members", icon: "people" },
];

export const navLinks = [
  { name: "Home", path: "/" },
  { name: "About Us", path: "/about" },
  { name: "Student Registration", path: "/admissions" },
  { name: "College Corner", path: "/colleges" },
  { name: "Circular & GOs", path: "/circulars" },
  { name: "Gallery", path: "/gallery" },
  { name: "Careers", path: "/careers" },
  { name: "Useful Links", path: "/useful-links" },
  { name: "Department Login", path: "/login" },
  { name: "Contact Us", path: "/contact" }
];

export const colleges = [
  {
    slug: "eluru",
    name: "Govt Medical College, Eluru",
    district: "Eluru District",
    seats: 150,
    students: 640,

    faculty: 110,
    phone: "+91 78933 30491",
    email: "principalgmceluru@gmail.com",
    website: "https://gmceluru-ap-gov.com/",
    img: "/img/colleges/eluru/01.jpg",
    gallery: ["/img/colleges/eluru/01.jpg", "/img/colleges/eluru/02.jpg", "/img/colleges/eluru/03.jpg", "/img/colleges/eluru/04.jpg", "/img/colleges/eluru/05.jpg", "/img/colleges/eluru/06.jpg", "/img/colleges/eluru/07.jpg", "/img/colleges/eluru/08.jpg"],
    established: 2018,
    registerLink: "https://octopod.co.in/academy/admission/step/c29c0f5711c01d8246f216e22f2925cc/93753211ae79e880c6c4acae82a57e39",
    payLink: "https://octopod.co.in/student/admission/c29c0f5711c01d8246f216e22f2925cc"
  },
  {
    slug: "machilipatnam",
    name: "Govt Medical College, Machilipatnam",
    district: "Krishna District",
    seats: 150,
    students: 610,

    faculty: 108,
    phone: "+91 78933 30266",
    email: "principalgmcmachilipatnam@gmail.com",
    website: "https://www.gmcmachilipatnam-ap-gov.com/",
    img: "/img/colleges/machilipatnam/01.jpg",
    gallery: ["/img/colleges/machilipatnam/01.jpg", "/img/colleges/machilipatnam/02.jpg", "/img/colleges/machilipatnam/03.jpg", "/img/colleges/machilipatnam/04.jpg", "/img/colleges/machilipatnam/05.jpg", "/img/colleges/machilipatnam/06.jpg", "/img/colleges/machilipatnam/07.jpg", "/img/colleges/machilipatnam/08.jpg"],
    established: 2018,
    registerLink: "https://octopod.co.in/academy/admission/step/7695cda5470d63045cfece5acf48c71d/47c45d874469ec3f1ba371a0f07e5894",
    payLink: "https://octopod.co.in/student/admission/7695cda5470d63045cfece5acf48c71d"
  },
  {
    slug: "nandyal",
    name: "Govt Medical College, Nandyal",
    district: "Nandyal District",
    seats: 150,
    students: 595,

    faculty: 105,
    phone: "+91 83339 81688",
    email: "principalgmcnandyala@gmail.com",
    website: "https://www.gmcnandyal-ap-gov.com/",
    img: "/img/colleges/nandyal/01.jpg",
    gallery: ["/img/colleges/nandyal/01.jpg", "/img/colleges/nandyal/02.jpg", "/img/colleges/nandyal/03.jpg", "/img/colleges/nandyal/04.jpg", "/img/colleges/nandyal/05.jpg", "/img/colleges/nandyal/06.jpg", "/img/colleges/nandyal/07.jpg", "/img/colleges/nandyal/08.jpg"],
    established: 2020,
    registerLink: "https://octopod.co.in/academy/admission/step/89e97a5661004d14d14c61b945bce55a/b930f958f6377d0cdd124f04b5186618",
    payLink: "https://octopod.co.in/student/admission/89e97a5661004d14d14c61b945bce55a"
  },
  {
    slug: "paderu",
    name: "Govt Medical College, Paderu",
    district: "Alluri Sitharama Raju District",
    seats: 50,
    students: 200,

    faculty: 72,
    phone: "+91 86390 90234",
    email: "govtmedcollegepaderu@gmail.com",
    website: "https://gmcpaderu.com/",
    img: "/img/colleges/paderu/01.jpg",
    gallery: ["/img/colleges/paderu/01.jpg", "/img/colleges/paderu/02.jpg"],
    established: 2022,
    registerLink: "#coming-soon",
    payLink: "#coming-soon"
  },
  {
    slug: "piduguralla",
    name: "Govt Medical College, Piduguralla",
    district: "Palnadu District",
    seats: 100,
    students: 200,

    faculty: 78,
    phone: "+91 77022 41364",
    email: "",
    website: "https://gmcpiduguralla.org/",
    img: "/img/colleges/piduguralla/gate.jpg",
    gallery: ["/img/colleges/piduguralla/gate.jpg", "/img/colleges/piduguralla/01.jpg", "/img/colleges/piduguralla/03.jpg", "/img/colleges/piduguralla/04.jpg", "/img/colleges/piduguralla/05.jpg", "/img/colleges/piduguralla/06.jpg", "/img/colleges/piduguralla/07.jpg", "/img/colleges/piduguralla/08.jpg"],
    established: 2023,
    registerLink: "#coming-soon",
    payLink: "#coming-soon"
  },
  {
    slug: "rajamahendravaram",
    name: "Govt Medical College, Rajamahendravaram",
    district: "East Godavari District",
    seats: 150,
    students: 625,

    faculty: 118,
    phone: "+91 93901 11371",
    email: "principalgmcrjyacademic@gmail.com",
    website: "https://www.gmcrajahmahendravaram-ap-gov.com/",
    img: "/img/colleges/rajamahendravaram/01.jpg",
    gallery: ["/img/colleges/rajamahendravaram/01.jpg", "/img/colleges/rajamahendravaram/02.jpg", "/img/colleges/rajamahendravaram/03.jpg", "/img/colleges/rajamahendravaram/04.jpg", "/img/colleges/rajamahendravaram/05.jpg", "/img/colleges/rajamahendravaram/06.jpg"],
    established: 2019,
    registerLink: "https://octopod.co.in/academy/admission/step/eee3567b14283517251cc064a792d630/d126d7eba1469a5819f6af8b3a42bab4",
    payLink: "https://octopod.co.in/student/admission/eee3567b14283517251cc064a792d630"
  },
  {
    slug: "vizianagaram",
    name: "Govt Medical College, Vizianagaram",
    district: "Vizianagaram District",
    seats: 150,
    students: 615,

    faculty: 113,
    phone: "+91 83339 92901",
    email: "principalgmcvzm@gmail.com",
    website: "https://gmcvizianagaram-ap-gov.com/",
    img: "/img/colleges/vizianagaram/01.jpg",
    gallery: ["/img/colleges/vizianagaram/01.jpg", "/img/colleges/vizianagaram/02.jpg", "/img/colleges/vizianagaram/03.jpg", "/img/colleges/vizianagaram/04.jpg", "/img/colleges/vizianagaram/05.jpg", "/img/colleges/vizianagaram/06.jpg", "/img/colleges/vizianagaram/07.jpg"],
    established: 2019,
    registerLink: "https://octopod.co.in/academy/admission/step/c9b9fe2d1f16dd87708c4e0bd27855b4/c4d52072db34bb8ee49eaa9db7b9ea20",
    payLink: "https://octopod.co.in/student/admission/c9b9fe2d1f16dd87708c4e0bd27855b4"
  }
];

export const collegeNames = { eluru: "GMC Eluru", machilipatnam: "GMC Machilipatnam", nandyal: "GMC Nandyal", paderu: "GMC Paderu", piduguralla: "GMC Piduguralla", rajamahendravaram: "GMC Rajamahendravaram", vizianagaram: "GMC Vizianagaram" };
export const galleryImages = Object.entries(collegeProfiles).flatMap(([slug, p]) =>
  p.gallery.map(g => ({ url: g.url, title: g.title, category: collegeNames[slug], src: g.src }))
);

export const boardMembers = [
  { role: "Chairman", title: "Special Chief Secretary / Principal Secretary / Secretary, Health, Medical & Family Welfare Department, Government of Andhra Pradesh" },
  { role: "Director", title: "Vice Chairman and Managing Director of APMERC" },
  { role: "Director", title: "Secretary to Government, Finance Department, Government of Andhra Pradesh" },
  { role: "Director", title: "Commissioner, Health and Family Welfare, Government of Andhra Pradesh" },
  { role: "Director", title: "Chief Executive Officer, Dr. YSR Aarogyasri Health Care Trust, Government of Andhra Pradesh" },
  { role: "Director", title: "Vice Chairman and Managing Director, APMSIDC" },
  { role: "Director", title: "Commissioner, Andhra Pradesh Vaidya Vidhana Parishad, Government of Andhra Pradesh" },
  { role: "Director and Member Convener", title: "Director of Medical Education (Administration), Government of Andhra Pradesh" }
];

export const circulars = [
  { id: 1, title: "Important Instructions to Students & Parents — MBBS Admissions 2026-27 (GMC Paderu)", date: "15 Jun 2026", type: "Notification", gono: "GMC-PDR/ADM/2026", url: "https://gmcpaderu.com/admin/upload/Instructions%20to%20students%20and%20parents%20(1).pdf" },
  { id: 2, title: "Fee Structure — Government Medical College, Piduguralla", date: "08 Jun 2026", type: "Circular", gono: "GMC-PGL/FEE/2026", url: "https://gmcpiduguralla.org/fee-structure/" },
  { id: 3, title: "NMC Letter of Permission & Distribution of Seats — GMC Piduguralla", date: "01 Jun 2026", type: "Notification", gono: "NMC/LOP/2026", url: "https://gmcpiduguralla.org/nmc-mci-approvals/" },
  { id: 4, title: "APMERC–DME Letter: Remittance of Competent Authority & NRI Quota Fees to APMERCL", date: "22 May 2026", type: "Order", gono: "APMERC/DME/2023", url: "https://www.gmcnandyal-ap-gov.com/wp-content/uploads/2023/08/APMERC-DME-Letter.pdf" },
  { id: 5, title: "Hostel Fee Structure — Government Medical College, Paderu", date: "14 May 2026", type: "Circular", gono: "GMC-PDR/HST/2025", url: "https://gmcpaderu.com/admin/upload/hostel%20fee%20structure%20(3).pdf" },
  { id: 6, title: "Sample Bond for Admission to MBBS Course", date: "03 May 2026", type: "Order", gono: "DME/BOND/2025", url: "https://gmcpaderu.com/admin/upload/Bond%20for%20admission%20sample.pdf" },
  { id: 7, title: "The Andhra Pradesh Medical Education & Research Corporation Act, 2021 (Act No. 7 of 2021)", date: "20 May 2021", type: "Order", gono: "Act No. 7 of 2021", url: "https://upload.indiacode.nic.in/view-casepdf?id=AC_AP_56_361_00015_00015_1628746566073&type=act" },
  { id: 8, title: "APMERC Bill, 2021 — Legislative Summary (PRS India)", date: "20 May 2021", type: "Notification", gono: "APMERC/BILL/2021", url: "https://prsindia.org/bills/states/the-andhra-pradesh-medical-education-and-research-corporation-apmerc-bill-2021" }
];

export const careers = [
  { title: "Assistant Professor - Anatomy", location: "Multiple Colleges", type: "Full-time", posted: "3 days ago", positions: 12, applyLink: "mailto:md.apmerc@gmail.com?subject=Application%20for%20Assistant%20Professor%20-%20Anatomy" },
  { title: "Associate Professor - Surgery", location: "GMC Rajamahendravaram", type: "Full-time", posted: "1 week ago", positions: 4, applyLink: "mailto:md.apmerc@gmail.com?subject=Application%20for%20Associate%20Professor%20-%20Surgery" },
  { title: "Senior Resident - Radiology", location: "GMC Machilipatnam", type: "Contract", posted: "2 weeks ago", positions: 6, applyLink: "mailto:md.apmerc@gmail.com?subject=Application%20for%20Senior%20Resident%20-%20Radiology" },
];

export const usefulLinks = [
  { name: "National Medical Commission (NMC)", url: "https://www.nmc.org.in/", desc: "Regulatory authority for medical education in India" },
  { name: "Ministry of Health & Family Welfare", url: "https://www.mohfw.gov.in/", desc: "Government of India health policy portal" },
  { name: "Health, Medical & Family Welfare Dept, AP", url: "https://hmfw.ap.gov.in/", desc: "State health & medical education department" },
  { name: "AP State Government Portal", url: "https://www.ap.gov.in/", desc: "Official state government website" },
  { name: "NEET UG — National Testing Agency", url: "https://neet.nta.nic.in/", desc: "Common entrance for MBBS admissions" },
  { name: "Dr. NTR University of Health Sciences", url: "https://drntr.uhsap.in/", desc: "Affiliating university for medical colleges" },
  { name: "APMSIDC", url: "https://apmsidc.ap.gov.in/", desc: "AP Medical Services & Infrastructure Development Corporation" },
  { name: "Dr. NTR Vaidya Seva (Aarogyasri)", url: "https://ntrvaidyaseva.ap.gov.in/", desc: "State health assurance scheme" },
  { name: "Commissionerate of Health & Family Welfare", url: "https://apchfw.ap.gov.in/", desc: "CHFW dashboard & public health programmes" },
  { name: "NEET-PG — National Board of Examinations in Medical Sciences", url: "https://natboard.edu.in/viewnbeexam?exam=neetpg", desc: "Official NEET-PG examination information and applicant portal" },
  { name: "Andhra Pradesh Medical Council", url: "https://apmc.ap.gov.in/", desc: "Official AP Medical Council website for registration of medical practitioners" }
];

export const announcements = [
  { id: 1, date: "15 Jun 2026", text: "MBBS Admissions 2026-27: Student registration and fee payment links are live for all seven Government Medical Colleges.", urgent: true },
  { id: 2, date: "08 Jun 2026", text: "Revised fee structure for Competent Authority (self-financing) and NRI quota seats notified — G.O.Ms.No.42.", urgent: false },
  { id: 3, date: "01 Jun 2026", text: "Recruitment of Assistant Professors across Anatomy, Physiology, Biochemistry & Pharmacology — apply before 31 October 2026.", urgent: true },
  { id: 4, date: "22 May 2026", text: "Infrastructure grant sanctioned for GMC Piduguralla teaching hospital expansion.", urgent: false },
  { id: 5, date: "14 May 2026", text: "Academic Calendar 2026-27 released for all APMERCL colleges affiliated to Dr. YSR University of Health Sciences.", urgent: false },
];

export const objectives = [
  "Revitalise tertiary hospitals and health-care services across Andhra Pradesh",
  "Strengthen existing Government medical colleges and teaching hospitals",
  "Construct new medical colleges, nursing colleges, super-speciality hospitals and cancer centres",
  "Raise funds through capital markets, bank borrowings and other financial instruments",
  "Act as holding entity for assets and revenues of institutions under its purview",
  "Manage fee receipts from Competent Authority and NRI quota seats for institutional development",
];

export const milestones = [
  { year: "2020", title: "Cabinet Approval", text: "AP Cabinet approves formation of a Medical Education & Research Corporation to fund 16 new medical colleges." },
  { year: "Feb 2021", title: "Incorporation", text: "APMERC Ltd incorporated on 24 February 2021 under the Companies Act, 2013 (CIN U74999AP2021SGC117458); Board constituted vide G.O.Ms.No.9." },
  { year: "May 2021", title: "APMERC Act", text: "The APMERC Bill introduced in the Assembly on 20 May 2021 and enacted as Act No. 7 of 2021." },
  { year: "2023", title: "First Colleges Operational", text: "GMC Eluru, Machilipatnam, Nandyal, Rajamahendravaram & Vizianagaram commence MBBS batches with 150 seats each." },
  { year: "2024", title: "Expansion", text: "GMC Paderu and Piduguralla join the network; total intake reaches 900 MBBS seats per year." },
  { year: "2025", title: "One College per District", text: "Continuing mandate to ensure a Government medical college in every district of Andhra Pradesh." },
];

export const quickServices = [
  { title: "Student Registration", desc: "Register & pay fees for your allotted college", path: "/admissions", icon: "graduation", tone: "orange" },
  { title: "College Corner", desc: "Profiles of all seven Government Medical Colleges", path: "/colleges", icon: "hospital", tone: "yellow" },
  { title: "Circulars & GOs", desc: "Latest notifications, orders & academic calendars", path: "/circulars", icon: "document", tone: "red" },
  { title: "Careers", desc: "Faculty, resident and administrative openings", path: "/careers", icon: "briefcase", tone: "orange" },
  { title: "Gallery", desc: "Campuses, hospitals, labs and libraries", path: "/gallery", icon: "gallery", tone: "yellow" },
  { title: "Department Login", desc: "Secure access for APMERCL personnel", path: "/login", icon: "lock", tone: "red" },
];

export const hqContact = {
  address: "Registered Office: Phy Care Building, IT Park, Mangalagiri, Guntur District, Andhra Pradesh 522503",
  address2: "Directorate of Medical Education, Vijayawada, Andhra Pradesh 520008",
  phone: "+91 9177244410",
  email: "md.apmerc@gmail.com",
};

export const socialLinks = [
  { name: "Facebook", url: "https://www.facebook.com/AndhraPradeshCM" },
  { name: "X", url: "https://x.com/AndhraPradeshCM" },
  { name: "YouTube", url: "https://www.youtube.com/@AndhraPradeshCM" },
  { name: "Instagram", url: "https://www.instagram.com/andhrapradeshcm/" }
];
export const pageBanners = {
  about: "/img/banner-about.jpg", colleges: "/img/banner-colleges.jpg", admissions: "/img/banner-admissions.jpg",
  gallery: "/img/banner-gallery.jpg", circulars: "/img/banner-circulars.jpg", careers: "/img/banner-careers.jpg",
  links: "/img/banner-links.jpg", login: "/img/banner-login.jpg", contact: "/img/banner-contact.jpg",
};

export const hqPhotos = [
  { url: "/img/hq/2.jpg", title: "APMERCL Registered Office — Phycare Building, IT Park, Mangalagiri", pos: "center" },
  { url: "/img/hq/1.jpg", title: "Main entrance & name board", pos: "center 60%" },
  { url: "/img/hq/4.jpg", title: "Phycare Building — front elevation", pos: "center 40%" },
  { url: "/img/hq/5.jpg", title: "Entrance gate & portico", pos: "center 55%" },
  { url: "/img/hq/3.jpg", title: "Glass facade — IT Park, Mangalagiri", pos: "center 45%" },
];

export const admissionDeadline = {
  date: "2026-10-31T23:59:59+05:30",
  label: "MBBS Registration 2026-27 closes 31 October 2026, 11:59 PM IST",
};

export const events = [
  { url: "/img/events/7.jpg", title: "Hon'ble CM Shri Nara Chandrababu Naidu inaugurates the ₹50-crore Centenary Building at Andhra Medical College", date: "26 Apr 2025", place: "Visakhapatnam", source: "https://www.thehindu.com/news/cities/Visakhapatnam/kgh-will-be-developed-into-a-centre-of-excellence-on-the-lines-of-aiims-delhi-cm-naidu/article69495216.ece" },
  { url: "/img/events/6.jpg", title: "Hon'ble CM Shri Nara Chandrababu Naidu — Government Medical Colleges to stay Government-run; free OP services assured", date: "12 Sep 2025", place: "Amaravati", source: "https://www.newindianexpress.com/states/andhra-pradesh/2025/Sep/13/andhra-cm-naidu-assures-no-privatisation-of-medical-colleges-amid-ppp-criticism" },
  { url: "/img/events/5.jpg", title: "CM approves Government Medical College, Piduguralla for 2026-27 — 100 MBBS seats", date: "07 Jan 2026", place: "Piduguralla", source: "https://www.deccanchronicle.com/southern-states/andhra-pradesh/cm-approves-to-start-medical-college-at-piduguralla-for-202627-with-100-seats-1929044" },
  { url: "/img/events/2.jpg", title: "Hon'ble CM Shri Nara Chandrababu Naidu at AIIMS Mangalagiri's first convocation — 10 acres allotted for expansion", date: "17 Dec 2024", place: "Mangalagiri", source: "https://www.thehindu.com/news/national/andhra-pradesh/ap-chief-minister-chandrababu-naidu-emphasises-transformative-role-of-technology-in-healthcare/article68995900.ece" },
  { url: "/img/events/3.jpg", title: "Hon'ble President with Chief Minister at the AIIMS Mangalagiri convocation ceremony", date: "17 Dec 2024", place: "Mangalagiri", source: "https://www.newindianexpress.com/states/andhra-pradesh/2024/Dec/18/cm-chandrababu-naidu-allocates-10-acres-for-aiims-expansion" },
  { url: "/img/events/1.jpg", title: "Chief Minister inaugurates the Centenary Building at Andhra Medical College, Visakhapatnam", date: "26 Apr 2025", place: "Visakhapatnam", source: "https://www.ap7am.com/en/99657/chief-minister-chandrababu-inaugurates-centenary-building-at-visakhapatnam-amc" },
  { url: "/img/events/4.jpg", title: "Chief Minister reviews the development of new Government Medical Colleges at the Collectors' Conference", date: "Dec 2025", place: "Amaravati", source: "https://telanganatoday.com/cm-chandrababu-naidu-defends-ppp-model-for-new-medical-colleges-in-andhra-pradesh" },
];
